import React from 'react'
import classes from "../taskbar/taskbar.module.css";

function taskbar() {
  return (
    <div className={classes.taskbar_main}>
        <div className={classes.taskbar_align}>
            <a href='#home'>Home</a>
            <a href='#about'>About-Me</a>
            <a href='#project'>Projects</a>
            <a href='#contact'>Contact</a>
        </div>
    </div>
  )
}

export default taskbar